module.exports = __webpack_public_path__ + "img/3.ef568485.png";